import { useQuery } from "@tanstack/react-query";
import sessionsService from "@/features/sessions/services/sessionsService";
import type { SessionWithDetails } from "@/features/sessions/types";
import DURATIONS from "@/shared/constants/durations";
import { sessionsKeys } from "./sessionsQueryKeys";

/**
 * Fetches a single session by ID with resolved book and venue details
 *
 * @param sessionId - Session document ID to fetch
 */
export function useSessionById(sessionId: string) {
    return useQuery<SessionWithDetails, Error>({
        enabled: !!sessionId,
        gcTime: DURATIONS.FIVE_MINUTES,
        queryFn: () => sessionsService.getSessionById(sessionId),
        queryKey: sessionsKeys.sessions.detail(sessionId),
        staleTime: DURATIONS.FIVE_MINUTES,
    });
}
